<template>
    <form @submit.prevent="signup" v-if="!submitting">
        <label>Brugernavn:</label>
        <input required type="text" id="username" v-model="username">

        <label>Kodeord:</label>
        <input required type="password" id="password" suggested="new-password" v-model="password">

        <label for="remember_me" class="remember-label">
            <input type="checkbox" v-model="checked" @change="this.persistence = this.checked ? 'long' : 'short'">
            <span>Husk mig</span>
        </label>

        <p v-if="this.errorMessage" class="error-message">{{  this.errorMessage }}</p>

        <button class="signup">Opret konto</button>
    </form>
</template>

<script>
import axios from "axios"
import EventBus from "../eventBus.js"
import { useToast } from "vue-toastification"

const toast = useToast();

export default {
    data() {
        return {
            checked: true,
            submitting: false,
            errorMessage: null,
            username: "",
            password: "",
            persistence: "long"
        }
    },
    beforeRouteEnter(to, from, next) {
        const storedProfile = localStorage.getItem("profile");

        if (storedProfile && JSON.parse(storedProfile).id != -1) {
            next("/");
        } else {
            next();
        }
    },
    methods: {
        async signup() {
            if (this.password.length < 8) {
                this.errorMessage = "Adgangskoden skal minimum være 8 tegn"
                toast.error(this.errorMessage);
            } else {
                this.submitting = true
                try {
                    const response = await axios.post("/signup", {
                        username: this.username,
                        password: this.password,
                        persistence: this.persistence
                    });
                    if (response.status == 200) {
                        EventBus.emit("login-profile", {
                            profile: response.data.profile,
                            auth_token: response.data.authorization.token
                        });
                        this.$router.push("/")
                    }
                } catch (err) {
                    console.error(err);
                    this.errorMessage = err.response.data.detail;
                    if (this.errorMessage != "") {
                        toast.error(this.errorMessage);
                    }
                } finally {
                    this.submitting = false
                }
            }
        }
    }
}
</script>

<style scoped>
    body {
        background-color: #636363;
    }
    .remember-label {
        display: flex;
        align-items: center;
        gap: 5px;
        justify-content: flex-start; 
        margin-top: 10px;
        margin-left: -5px;
        font-size: 14px;
    }
    form {
        max-width: 420px;
        margin: 100px auto;
        text-align: left;
        background: #979696;
        padding: 40px;
        border-radius: 10px
    }
    label {
        color: yellow;
        display: inline-block;
        margin: 25px 0 15px;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: bold;
    }
    input:not([type="checkbox"]) {
        display: block;
        padding: 10px;
        border-radius: 5px;
        width: 100%;
        box-sizing: border-box;
        border: none;
        border-bottom: 1px solid #ddd;
        color: #555;
    }
    .signup {
        margin: 30px auto 0;
        display: block;
        letter-spacing: 1px;
        border-radius: 15px;
        background-color: yellow;
        font-size: 0.95em;
        text-transform: uppercase;
        color: #666;
        border: none;
        width: 145px;
        height: 35px;
        cursor: pointer;
        font-weight: bold;
    }
    .signup:hover {
        background-color: gold;
    }
    .error-message {
        color: rgb(158, 37, 37);
        margin-left: 0;
        padding: 0;
    }
</style>
